export default "https://cdn-static.gokick.com/assets/89c12df47656b56f32e50d5631dab02a560652ab/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";